/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, action: NonNullable<unknown> }} Seo_Endpoint_Q_SdkInputs */

const en_seo_endpoint_q_sdk = /** @type {(inputs: Seo_Endpoint_Q_SdkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Is there an SDK for the ${i?.name} ${i?.action} API?`)
};

const zh_hans1_seo_endpoint_q_sdk = /** @type {(inputs: Seo_Endpoint_Q_SdkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ${i?.action} API 有 SDK 吗？`)
};

const pt_br2_seo_endpoint_q_sdk = /** @type {(inputs: Seo_Endpoint_Q_SdkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Existe um SDK para o endpoint ${i?.action} da API para ${i?.name}?`)
};

const es_seo_endpoint_q_sdk = /** @type {(inputs: Seo_Endpoint_Q_SdkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Hay un SDK para el endpoint ${i?.action} de la API de ${i?.name}?`)
};

const fr_seo_endpoint_q_sdk = /** @type {(inputs: Seo_Endpoint_Q_SdkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Existe-t-il un SDK pour l’API ${i?.name} ${i?.action} ?`)
};

const de_seo_endpoint_q_sdk = /** @type {(inputs: Seo_Endpoint_Q_SdkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gibt es ein SDK für die ${i?.name}-${i?.action}-API?`)
};

const ru_seo_endpoint_q_sdk = /** @type {(inputs: Seo_Endpoint_Q_SdkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Есть ли SDK для API ${i?.name} ${i?.action}?`)
};

const it_seo_endpoint_q_sdk = /** @type {(inputs: Seo_Endpoint_Q_SdkInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esiste un SDK per l'API ${i?.name} ${i?.action}?`)
};

/**
* | output |
* | --- |
* | "Is there an SDK for the {name} {action} API?" |
*
* @param {Seo_Endpoint_Q_SdkInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_endpoint_q_sdk = /** @type {((inputs: Seo_Endpoint_Q_SdkInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Endpoint_Q_SdkInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_endpoint_q_sdk(inputs)
	if (locale === "pt-BR") return pt_br2_seo_endpoint_q_sdk(inputs)
	if (locale === "es") return es_seo_endpoint_q_sdk(inputs)
	if (locale === "fr") return fr_seo_endpoint_q_sdk(inputs)
	if (locale === "de") return de_seo_endpoint_q_sdk(inputs)
	if (locale === "ru") return ru_seo_endpoint_q_sdk(inputs)
	if (locale === "it") return it_seo_endpoint_q_sdk(inputs)
	return en_seo_endpoint_q_sdk(inputs)
});